<template>
  <form class="entryForm" onsubmit="return false" @submit="send">
    <div class="row wrap justify-space column-s">
      <div class="column grid-3 grid-12-s">
        <label>Data</label>
        <input v-model="form.data" type="date" class="input" required />
      </div>

      <div class="column grid-2-g grid-6-m grid-12-s">
        <label>Tipo</label>
        <select v-model="form.tipo" required>
          <option value="">Selecione</option>
          <option value="pagamento">Pagamento</option>
          <option value="faturamento">Faturameto</option>
        </select>
      </div>

      <div class="column grid-3-g grid-6-m grid-12-s">
        <label>Valor</label>

        <Money
          onkeydown="function n() { let e = window.event ;return e.key === '-' ? e.preventDefault() : null};n()"
          v-model="form.lancamento"
          placeholder="Valor (R$)"
          v-bind="money"
        />
      </div>

      <div class="column grid-4-g grid-6-m grid-12-s">
        <label>Observações</label>
        <input v-model="form.observacao" placeholder="Observações" />
      </div>
    </div>

    <div v-if="form.nome_criado_por" class="info row wrap column-s justify-around">
      <div class="text-center grid-5">
        <label>Criado por</label>
        <div>{{ form.nome_criado_por }} em {{ form.criado_em | date }}</div>
      </div>
      <div class="text-center grid-5" v-if="form.nome_alterado_por">
        <label>Alterado por</label>
        <div>{{ form.nome_alterado_por }} em {{ form.alterado_em | date }}</div>
      </div>
    </div>

    <div class="controls row justify-center">
      <br /><br />
      <Button type="submit" :loader="loader" layout="green-go"
        ><i class="fa fa-edit" />{{ form.update ? "ATUALIZAR" : "ADICIONAR" }}</Button
      >&nbsp;&nbsp;&nbsp;
      <Button
        v-if="form.update"
        type="button"
        @click="del"
        :loader="loader"
        layout="red-go"
        ><i class="fa fa-trash" /> APAGAR</Button
      >
    </div>
  </form>
</template>

<script>
import Button from "@/components/Button.vue";
import { Money } from "v-money";

export default {
  name: "EntryForm",
  components: { Button, Money },
  props: { form: Object },
  data() {
    return {
      loader: false,
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
    };
  },
  methods: {
    async send() {
      this.loader = true;
      await this.form.send(this.form);
      this.loader = false;
    },
    del() {
      this.loader = true;
      this.form
        .del(this.form)
        .then(() => (this.loader = false))
        .catch(() => (this.loader = false));
    },
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.entryForm
  @include form
</style>
